import React from 'react';
import { CprIcon } from 'canopy-styleguide!sofe';

import styles from './nav-search.styles.css';

export const RecentResults = ({ userId, storageKey, closeNav }) => {
  const list = JSON.parse(localStorage.getItem(`${userId}-${storageKey}`) || '[]');
  return (
    <>
      <div className="cps-margin-top-16">
        <CprIcon name="communication-chat-bubbles" className="cps-margin-right-8" />
        <span className="cps-wt-semibold">Recent contacts</span>
      </div>
      {list.length > 0 ? (
        list.map(contact => (
          <div key={contact.id} className={`cps-margin-top-8 ${styles.searchLink}`} style={{ fontStyle: 'italic' }}>
            <a
              href={`#/client/${contact.id}`}
              onClick={closeNav}
              style={{ display: 'block', color: '#52555a', textDecoration: 'none', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>
              {contact.name}
            </a>
          </div>
        ))
      ) : (
        <div className={`cps-margin-top-8`} style={{ fontStyle: 'italic' }}>
          None
        </div>
      )}
    </>
  );
};
